export default "__VITE_ASSET__DS92IIND__"